import Address from "./Address";
import Role from "./Role";

export default class OrganizationSettings {
  public id: string
  public name: string
  public nxtPortId: string | null
  public addresses: Address[]
  public vat: string
  public duns: string
  public eori: string
  public dateAdded: string
  public roles: Role[]
  public assets?: any[]
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/OrganizationSettings.ts